
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function FeaturesSection() {
  const { t } = useTranslation();
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const features = [
    {
      icon: 'ri-line-chart-line',
      title: t('features.realtime.title'),
      description: t('features.realtime.desc'),
      color: 'from-yellow-400 to-yellow-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('features.security.title'),
      description: t('features.security.desc'),
      color: 'from-green-400 to-green-600'
    },
    {
      icon: 'ri-global-line',
      title: t('features.licensed.title'),
      description: t('features.licensed.desc'),
      color: 'from-blue-400 to-blue-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('features.support.title'),
      description: t('features.support.desc'),
      color: 'from-purple-400 to-purple-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/5 via-transparent to-yellow-400/5"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-yellow-600 to-yellow-800 bg-clip-text text-transparent">
            {t('features.title')}
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer border border-gray-100 hover:border-yellow-200 ${
                hoveredCard === index ? 'scale-105' : ''
              }`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${feature.color} rounded-2xl flex items-center justify-center mb-6 transform transition-all duration-300 ${
                hoveredCard === index ? 'rotate-12 scale-110' : ''
              }`}>
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-yellow-600 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
              
              {/* Animated border */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-r ${feature.color} opacity-0 transition-opacity duration-300 ${
                hoveredCard === index ? 'opacity-10' : ''
              }`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
